<!-- Posts grid -->
<div class="col-sm-12 col-md-4 col-xl-4 mb-4" *ngFor="let content of postGridContent ? postGridContent:[]">
	<div class="card border-0 border-rad m-0 h-100">
     <a href="{{content?.link}}" target="_blank"><img class="border-rad-top img-fluid w-100 tile-image" [src] ="content?.image" alt="Card image cap" width="370" height="253" /></a>
		<div class="card-body px-4 pt-4 border-rad-bottom">
			<h5 class="card-title mb-3"><a href="{{content?.link}}" target="_blank">{{content?.title}}</a></h5>
			<div class="card-text mb-3">
				<app-dynamic-content
					[contentId]="'post-grid-desc'"
					[htmlContent]="content?.description">
				</app-dynamic-content>
			</div>
		</div>
	</div>
</div>

